import { ErrorHandler, Injectable } from '@angular/core';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

    handleError(error: any): void {

        if (error?.message?.includes('Loading chunk')) {
            console.warn('Chunk error detected. Reloading...');
            window.location.reload();
            return;
        }

        console.error(error);
    }
}